import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const LeftDecorationIcon = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)
  if (!state.locationDesignConfig) return null

  return (
    <svg
      {...props}
      viewBox="0 0 780 371"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M221 370.997C117.135 371.269 14.2472 350.936 -81.7059 311.175C-177.659 271.414 -264.772 213.015 -338 139.36L-198.633 0C-87.3389 111.287 63.6075 173.807 221 173.807C378.393 173.807 529.339 111.287 640.634 0L780 139.36C706.783 213.031 619.673 271.44 523.717 311.202C427.762 350.964 324.868 371.288 221 370.997Z"
        fill={state.locationDesignConfig?.baseColors.primaryLighter}
      />
    </svg>
  )
}

export default LeftDecorationIcon
